import '../../styles/components/button.scss';

const Button = (props) => {
    const { value } = props;

    return <input value={value} className="button" type='submit' />;
};


export default Button;